import type { HelpFile } from '../../types/help'
import { AutoAssignRuleExecutionsTestIds } from '../../../testids/AutoAssignRuleExecutionsTestIds'

export const autoAssignRuleExecutionsHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRuleExecutionsTestIds.autoAssignRuleExecutions]:
      'History of auto-assign rule runs. Each row records when a rule was evaluated, how many identities matched, and how many access grants were added or removed as a result.',
    [AutoAssignRuleExecutionsTestIds.btnClearRuleFilter]:
      'Remove the active rule filter and show executions of all auto-assign rules.',
    [AutoAssignRuleExecutionsTestIds.colRule]:
      'Auto-Assign Rule that produced this execution.',
    [AutoAssignRuleExecutionsTestIds.colExecutedAt]:
      'Timestamp at which the rule was evaluated.',
    [AutoAssignRuleExecutionsTestIds.colStatus]:
      'Outcome of the execution — completed, failed, or partially applied.',
    [AutoAssignRuleExecutionsTestIds.colMatched]:
      'Number of identities that matched the rule condition during this execution.',
    [AutoAssignRuleExecutionsTestIds.colAdded]:
      'Number of access grants added because the matched identities did not yet hold them.',
    [AutoAssignRuleExecutionsTestIds.colRemoved]:
      'Number of access grants revoked because the identities no longer match the rule condition.',
    [AutoAssignRuleExecutionsTestIds.colDuration]:
      'Wall-clock time the execution took from start to completion.',
  },
}
